/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {BaseComponent, XhrHttpModule} from "@intuitionrobotics/thunderstorm/frontend";
import * as React from "react";
import {Card} from "../widget/Card";
import {formatAlertDatetime} from "./alerts/util";
import dayjs from "../../utils/dayjs";
import {FONTS} from "@res/fonts";
import {DB_Patient} from "@app/app-shared/patient";
import {Api_GetFallRisk, Response_FallRisk} from "@app/app-shared/api";
import {HttpMethod} from "@intuitionrobotics/thunderstorm";

type Props = {
    patient: DB_Patient
}

type State = {
    fallRisk: boolean | null
    timestamp: number | null
}

export class FallRiskPanel
    extends BaseComponent<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {fallRisk: null, timestamp: null};
    }

    componentDidMount() {
        this.fetchData(this.props.patient.unitId);
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.patient.unitId !== this.props.patient.unitId)
            this.fetchData(this.props.patient.unitId);
    }

    private fetchData = (unitId: string) => {
        XhrHttpModule
            .createRequest<Api_GetFallRisk>(HttpMethod.POST, "get-fall-risk")
            .setRelativeUrl("/v1/patient/fall-risk")
            .setJsonBody({unitId})
            .setOnError("Failed to retrieve fall risk data")
            .execute((response: Response_FallRisk) => {
                this.setState({fallRisk: response.fallRisk, timestamp: response.timestamp});
            });
    };

    private formatTimestamp = (timestamp: number | null) => {
        if (timestamp === null)
            return "N/A";

        const {date} = formatAlertDatetime(timestamp);
        const time = dayjs(timestamp).format("hh:mm A");
        return date === " Today" ? ` Today at ${time}` : `${date} at ${time}`;
    };

    private formatFallRisk = (fallRisk: boolean | null) => {
        if (fallRisk === null)
            return "N/A";
        return fallRisk ? "Yes" : "No";
    };

    render() {
        const {fallRisk, timestamp} = this.state;

        return <div>
            <Card style={{paddingBottom: "20px"}}>
                <h1 style={{position: "relative", left: "20px", top: "10px"}}>
                    {FONTS.reg_14_gray(`Fall risk:`)} {FONTS.bold_14_gray_4(this.formatFallRisk(fallRisk))}
                </h1>
                <h1 style={{position: "relative", left: "20px", top: "10px"}}>
                    {FONTS.reg_14_gray('Computed on:')} {FONTS.bold_14_gray_4(this.formatTimestamp(timestamp))}
                </h1>
            </Card>
        </div>;
    }
}
